import * as actions from './actions'
import * as mutations from './mutations'
import state from './state'

const namespaced = true

export default {
  actions,
  state,
  mutations,
  namespaced
}